import React from 'react';
import { Text14Light, Text18Bold, Text20Bold } from '../utils/Text/Text.styles';
import {
  Card,
  CardsContainer,
  Container,
  DescriptionContainer,
  DescriptionText,
  HeaderContainer,
  ListContainer,
  StyledButton,
  TitleContainer,
} from './ChoseOnboardingType.styles';
import { INFLUENCER_REQUEST_ONBOARDING_TYPE } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { updateOnboardingType } from '../../store/slices/influencerRequest/asyncThunks';
import { notifyError } from '../../utils/notify';
import { selectInfluencerRequestActionsPending } from '../../store/slices/influencerRequest/slice';

const ChoseOnboardingType = () => {
  const dispatch = useDispatch();
  const { updateOnboardingType: updateOnboardingTypePending } = useSelector(selectInfluencerRequestActionsPending);

  const setOnboardingType = onboardingType => {
    dispatch(updateOnboardingType({ onboardingType }))
      .unwrap()
      .then(() => {})
      .catch(err => {
        notifyError(err.message);
      });
  };
  return (
    <Container>
      <HeaderContainer>
        <Text20Bold>Content</Text20Bold>
      </HeaderContainer>
      <DescriptionContainer>
        <DescriptionText>Choose how you want to upload your media</DescriptionText>
      </DescriptionContainer>
      <CardsContainer>
        <Card>
          <TitleContainer>
            <Text18Bold>Assisted Easy Onboarding </Text18Bold>
            <Text14Light>Upload your content and let our team handle the rest.</Text14Light>
          </TitleContainer>
          <ListContainer>
            <Text14Light>• Upload pictures and videos</Text14Light>
            <Text14Light>• We set prices, write captions, and mass DMs</Text14Light>
          </ListContainer>
          <StyledButton
            title="Let the team handle it"
            onClick={() => setOnboardingType(INFLUENCER_REQUEST_ONBOARDING_TYPE.ASSISTED)}
            isLoading={updateOnboardingTypePending}
          />
        </Card>
        <Card>
          <TitleContainer>
            <Text18Bold>Self Onboarding</Text18Bold>
            <Text14Light>You control everything.</Text14Light>
          </TitleContainer>
          <ListContainer>
            <Text14Light>• Organize pictures, videos, bundles</Text14Light>
            <Text14Light>• Set your own pricing per content</Text14Light>
            <Text14Light>• Enter your own captions and mass DMs</Text14Light>
          </ListContainer>
          <StyledButton
            title="I’ll do it myself"
            onClick={() => setOnboardingType(INFLUENCER_REQUEST_ONBOARDING_TYPE.SELF)}
            isLoading={updateOnboardingTypePending}
          />
        </Card>
      </CardsContainer>
    </Container>
  );
};

export default ChoseOnboardingType;
